var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    _vm._l(_vm.itemData, function (item, i) {
      return _c(
        "v-expansion-panel-content",
        {
          key: i,
          scopedSlots: _vm._u(
            [
              {
                key: "header",
                fn: function () {
                  return [
                    !!item.SourceDetail
                      ? _c("span", [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "WaterQualityAnalyteLabResultUnitMismatchErrorModal.date"
                                )
                              ) + ":"
                            ),
                          ]),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm._f("formatDate")(
                                  item.SourceDetail.SampleDateTime
                                )
                              ) +
                              "\n        "
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "WaterQualityAnalyteLabResultUnitMismatchErrorModal.site"
                                )
                              ) + ":"
                            ),
                          ]),
                          _vm._v(
                            "\n        " +
                              _vm._s(item.SourceDetail.SiteId) +
                              "\n        "
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "WaterQualityAnalyteLabResultUnitMismatchErrorModal.analyte"
                                )
                              ) + ":"
                            ),
                          ]),
                          _vm._v(
                            "\n        " +
                              _vm._s(item.SourceDetail.AnalyteName) +
                              "\n      "
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n        " + _vm._s(item.Message) + "\n      "
                          ),
                        ]),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          !!item.SourceDetail
            ? _c(
                "v-layout",
                {
                  staticClass: "error-detail-body",
                  attrs: { row: "", wrap: "" },
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "border-bottom border-right",
                      attrs: { xs4: "" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "WaterQualityAnalyteLabResultUnitMismatchErrorModal.cocCode"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "border-bottom", attrs: { xs8: "" } },
                    [_vm._v(_vm._s(item.SourceDetail.CocCode))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "border-bottom border-right",
                      attrs: { xs4: "" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "WaterQualityAnalyteLabResultUnitMismatchErrorModal.labSampleId"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "border-bottom", attrs: { xs8: "" } },
                    [_vm._v(_vm._s(item.SourceDetail.LabSampleId))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "border-bottom border-right",
                      attrs: { xs4: "" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "WaterQualityAnalyteLabResultUnitMismatchErrorModal.databaseSampleId"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "border-bottom", attrs: { xs8: "" } },
                    [_vm._v(_vm._s(item.SourceDetail.SampleId))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "border-right", attrs: { xs4: "" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "WaterQualityAnalyteLabResultUnitMismatchErrorModal.message"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs8: "" } }, [
                    _vm._v(_vm._s(item.Message)),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }